import XLSX from "sheetjs-style";
import * as FileSaver from "file-saver";
import QRCode from "qrcode";


export function strToDate(strDate) {
  strDate = "20" + strDate;
  let year = parseInt(strDate.substring(0, 4));
  let month = parseInt(strDate.substring(4, 6));
  let day = parseInt(strDate.substring(6, 8));
  let hours = parseInt(strDate.substring(8, 10));
  let minutes = parseInt(strDate.substring(10, 12));
  let seconds = parseInt(strDate.substring(12, 14));
  let milliseconds = parseInt(strDate.substring(14, 17));
  return new Date(year, month - 1, day, hours, minutes, seconds, milliseconds);
}

export const exportToExcel = async ({ excelData, filename }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocuments.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const ws = XLSX.utils.json_to_sheet(excelData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, filename + fileExtension);
};

export const consoleLog = (message, ...args) => {
  if (process.env.NODE_ENV === "development") {
    console.log(message, ...args);
  }
};

export async function generateQr(text) {
  try {
  return await QRCode.toDataURL(text);
 } catch (err) {
  return console.error(err);
 }
}

export function utc(date) {
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();
  const milliseconds = date.getUTCMilliseconds();

  return new Date(Date.UTC(year, month, day, hours, minutes, seconds, milliseconds));
}

export const handleImageError = (event) => {
  event.target.src = "/Images/skash_emptypp.jpg"
};
